import React from "react";
import { Helmet } from "react-helmet-async";

const BASE = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");

const LOCAL_BUSINESS = {
  "@context": "https://schema.org",
  "@type": "Restaurant",
  name: "De Zeeuwse Tori",
  description: "Authentiek home-made Surinaams eten in Zeeland. Bestel online en haal op in Middelburg.",
  servesCuisine: "Surinaams",
  priceRange: "€€",
  url: BASE,
  telephone: "+31644582821",
  address: {
    "@type": "PostalAddress",
    streetAddress: "Duke Ellingtonstraat 109",
    postalCode: "4337 XT",
    addressLocality: "Middelburg",
    addressRegion: "Zeeland",
    addressCountry: "NL",
  },
};

export const Seo = ({ title, description, image, path = "", business = false }) => {
  const url = `${BASE}${path}`;
  const img = image ? `${BASE}/${image}` : null;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="De Zeeuwse Tori" />
      <meta property="og:locale" content="nl_NL" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <link rel="canonical" href={url} />
      <meta name="robots" content="index, follow" />
      {img && <meta property="og:image" content={img} />}
      {img && <meta property="og:image:width" content="1200" />}
      {img && <meta property="og:image:height" content="630" />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {img && <meta name="twitter:image" content={img} />}
      {business && (
        <script type="application/ld+json">{JSON.stringify(LOCAL_BUSINESS)}</script>
      )}
    </Helmet>
  );
};
